import account from "./acoount.png";
import hangul from "./hangul.png";
import home from "./home.png";
import logo from "./logo.png";
import mainbannerleft from "./main_L_left_bg.png";
import mainbannerright from "./main_L_right_bg.png";
import mainbannerbackground from "./main_BG.png";
import passwordcheck from "./passwordcheck.png";
import interests from "./interests.png";
import ventrue from "./venture.png";
import position1 from "./position1.png";
import position2 from "./position2.png";
import position3 from "./position3.png";
import position4 from "./position4.png";

const Image = {
  account,
  hangul,
  home,
  logo,
  mainbannerbackground,
  mainbannerleft,
  mainbannerright,
  passwordcheck,
  interests,
  ventrue,
  position1,
  position2,
  position3,
  position4
};

export default Image;
